import config from "../config";

export function setSectionNumber(targetSectionNumber: 1 | 2 | 3 | 4){
  const sectionIndicatorContainer: HTMLElement = document.getElementById("section-indicators");
  sectionIndicatorContainer.setAttribute('data-active-section-number', targetSectionNumber.toString());
  const sectionIndicators = document.querySelectorAll(".section-indicator");
  sectionIndicators.forEach((el: HTMLElement) => {
    const sectionNumber = parseInt(el.dataset.sectionNumber);
    if (targetSectionNumber === sectionNumber){
      el.classList.add('active');
    } else {
      el.classList.remove("active");
    }
  });
}

const duration = 1;

export default function () {
  const tl = gsap.timeline({
    scrollTrigger: {
      id: "section-indicators-1",
      trigger: "#scene-1-7-section-indicators-start",
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: `+=${config.scrollSpan}`,
    },
  });
  tl.to(
    "#section-indicators",
    {
      autoAlpha: 1,
      duration: duration,
      ease: Sine.easeInOut,
    }
  );

  const tlEnd = gsap.timeline({
    scrollTrigger: {
      id: `section-indicators-1-end`,
      trigger: `#scene-1-7-canvas-end`,
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: `+=${config.scrollSpan / 2}`,
    },
  });
  tlEnd.to(
    "#section-indicators",
    {
      duration: 0.5,
      autoAlpha: 0,
    },
    "start"
  );

  const tl2 = gsap.timeline({
    scrollTrigger: {
      id: "section-indicators-2",
      trigger: "#scene-2-section-indicators-start",
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: `+=${config.scrollSpan}`,
    },
  });
  tl2.to(
    "#section-indicators",
    {
      autoAlpha: 1,
      duration: duration,
      ease: Sine.easeInOut,
    }
  );
  const tl2End = gsap.timeline({
    scrollTrigger: {
      id: `section-indicators-2-end`,
      trigger: `#scene-2-end`,
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: `+=${config.scrollSpan / 2}`,
    },
  });
  tl2End.to(
    "#section-indicators",
    {
      duration: 0.5,
      autoAlpha: 0,
    },
    "start"
  );


  const tl3 = gsap.timeline({
    scrollTrigger: {
      id: "section-indicators-3",
      trigger: "#scene-3-section-indicators-start",
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset + config.scrollSpan}`;
      },
      end: `+=${config.scrollSpan}`,
    },
  });
  tl3.to(
    "#section-indicators",
    {
      autoAlpha: 1,
      duration: duration,
      ease: Sine.easeInOut,
    }
  );
  const tl3End = gsap.timeline({
    scrollTrigger: {
      id: `section-indicators-3-end`,
      trigger: `#scene-3-end`,
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: `+=${config.scrollSpan / 2}`,
    },
  });
  tl3End.to(
    "#section-indicators",
    {
      duration: 0.5,
      autoAlpha: 0,
    },
    "start"
  );

  const tl4 = gsap.timeline({
    scrollTrigger: {
      id: "section-indicators-4",
      trigger: "#scene-4-section-indicators-start",
      start: `top center+=${config.pinTextOffset}`,
      end: `+=50`,
    },
  });
  tl4.to(
    "#section-indicators",
    {
      autoAlpha: 1,
      duration: duration,
      ease: Sine.easeInOut,
    }
  );
  const tl4End = gsap.timeline({
    scrollTrigger: {
      id: `section-indicators-4-end`,
      trigger: `#scene-4-end`,
      start: `bottom bottom-=100`,
    },
    end: `+=50`,
  });
  tl4End.to(
    "#section-indicators",
    {
      duration: 0.5,
      autoAlpha: 0,
    },
    "start"
  );
}